import React from "react";

const Order = ({match}) => {
    return <div>Place order</div>
}

export default Order
